import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useLocation } from 'react-router-dom';

const Services = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [activeService, setActiveService] = useState(0);
  
  const services = [
    {
      id: 0,
      title: "CI/CD Implementation",
      icon: (
        <svg className="h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      ),
      description: "Automated pipelines for continuous integration and delivery",
      details: [
        "Pipeline design and implementation",
        "Automated testing integration",
        "Deployment automation",
        "Release orchestration",
        "Metrics and feedback loops"
      ],
      color: "from-indigo-500 to-purple-600"
    },
    {
      id: 1,
      title: "Infrastructure as Code",
      icon: (
        <svg className="h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
      description: "Managing infrastructure through code rather than manual processes",
      details: [
        "Cloud infrastructure automation",
        "Configuration management",
        "Environment provisioning",
        "Disaster recovery automation",
        "Multi-cloud solutions"
      ],
      color: "from-blue-500 to-indigo-600"
    },
    {
      id: 2,
      title: "Security Automation",
      icon: (
        <svg className="h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      description: "Security controls and compliance throughout your delivery pipeline",
      details: [
        "Automated security scanning",
        "Compliance as code",
        "Secrets management",
        "Identity and access automation",
        "Threat modeling automation"
      ],
      color: "from-emerald-500 to-teal-600"
    },
    {
      id: 3,
      title: "Cloud Optimization",
      icon: (
        <svg className="h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
        </svg>
      ),
      description: "Optimize cloud resources for maximum efficiency and cost savings",
      details: [
        "Cost optimization strategies",
        "Auto-scaling implementations",
        "Resource right-sizing",
        "Reserved instance planning",
        "Serverless architecture design"
      ],
      color: "from-rose-500 to-pink-600"
    }
  ];

  return (
    <div>
        <Header />
    <div className="relative bg-black py-20 text-white overflow-hidden">
        
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-indigo-700 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-1/3 w-80 h-80 bg-blue-600 rounded-full blur-3xl"></div>
      </div>
      
      {/* Code-like background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="h-full w-full overflow-hidden flex flex-col">
          {Array(20).fill().map((_, i) => (
            <div key={i} className="whitespace-nowrap text-xs font-mono">
              {Array(50).fill().map((_, j) => (
                <span key={j} className="mr-2">
                  {['function()', 'console.log', 'const app', 'deploy()', 'kubectl', 'terraform', '{ code }', '<DevOps />', 'pipeline{}', 'git push'][Math.floor(Math.random() * 10)]}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block">
            <span className="text-sm font-semibold px-3 py-1 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 text-white uppercase tracking-wide">
              Services
            </span>
          </div>
          <h2 className="mt-4 text-4xl font-extrabold sm:text-5xl">
            Our DevOps Solutions
          </h2>
          <div className="h-1 w-24 mx-auto mt-6 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full"></div>
          <p className="mt-6 text-xl text-gray-300 max-w-2xl mx-auto">
            End-to-end DevOps solutions to optimize your software delivery lifecycle
          </p>
        </div>

        {/* Service Tabs */}
        <div className="flex flex-wrap justify-center mb-8 gap-2">
          {services.map((service) => (
            <button
              key={service.id}
              onClick={() => setActiveService(service.id)}
              className={`px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 ${
                activeService === service.id
                ? `bg-gradient-to-r ${service.color} text-white shadow-lg`
                : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {service.title}
            </button>
          ))}
        </div>

        {/* Active Service Details */}
        <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl border border-gray-800">
          {/* Animated background gradient */}
          <div className={`absolute inset-0 bg-gradient-to-br ${services[activeService].color} opacity-10`}></div>
          
          <div className="lg:flex">
            {/* Left Panel - Service Overview */}
            <div className="lg:w-1/2 p-8 lg:p-12 relative">
              <div className={`inline-block p-4 rounded-2xl bg-gradient-to-br ${services[activeService].color}`}>
                {services[activeService].icon}
              </div>
              
              <h3 className="mt-6 text-2xl font-bold">
                {services[activeService].title}
              </h3>
              
              <p className="mt-4 text-gray-300 text-lg">
                {services[activeService].description}
              </p>
              
              <ul className="mt-8 space-y-4">
                {services[activeService].details.map((detail, index) => (
                  <li key={index} className="flex items-start">
                    <div className={`flex-shrink-0 h-6 w-6 rounded-full bg-gradient-to-r ${services[activeService].color} flex items-center justify-center mr-3 mt-1`}>
                      <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-gray-300">{detail}</span>
                  </li>
                ))}
              </ul>
              
            <Link to='/contact'>
              <button className={`mt-12 px-8 py-3 rounded-lg bg-gradient-to-r ${services[activeService].color} text-white font-medium inline-flex items-center group transition-all duration-300 hover:shadow-lg`}>
                Get Started
                <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              </Link>
            </div>
            
            {/* Right Panel - Visual */}
            <div className="lg:w-1/2 p-6 lg:p-12 flex items-center justify-center bg-black bg-opacity-30">
              <div className="h-64 max-w-full aspect-video rounded-xl bg-black bg-opacity-50 backdrop-blur-sm border border-gray-800 overflow-hidden relative flex items-center justify-center">
                {/* Terminal-like interface */}
                <div className="w-full max-w-md p-4 text-left font-mono text-sm">
                  <div className="flex items-center mb-4">
                    <div className="h-3 w-3 bg-red-500 rounded-full mr-2"></div>
                    <div className="h-3 w-3 bg-yellow-500 rounded-full mr-2"></div>
                    <div className="h-3 w-3 bg-green-500 rounded-full"></div>
                    <div className="ml-4 text-gray-400">terminal ~ devops-{services[activeService].title.toLowerCase().replace(/\s+/g, '-')}</div>
                  </div>
                  <div className="text-green-400">$ initializing {services[activeService].title.toLowerCase()}...</div>
                  <div className="text-gray-300 mt-2">Loading dependencies...</div>
                  <div className="text-gray-300">Configuring environment...</div>
                  <div className="text-gray-300">Deploying services...</div>
                  <div className="text-green-400 mt-2">$ {services[activeService].title} deployment successful!</div>
                  <div className="mt-2 flex items-center">
                    <span className="text-blue-400">$</span>
                    <span className="ml-1 animate-pulse">|</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-gray-400">
            Need a custom solution? Let's talk about your specific requirements.
          </p>
          <a href="#" className="mt-4 inline-flex items-center text-indigo-400 font-medium hover:text-indigo-300 transition-colors">
            Contact our experts
            <svg className="ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
     
    </div>
    <Footer />
    </div>
  );
};

export default Services;